<template>
  <v-content id="tela-principal">
    <!-- Container -->
    <v-container
      fluid
      grid-list-xl
      :class="step == 5 ? 'proposta__container-passo-5' : 'proposta__container'"
      v-if="!isStep5Edit"
    >
      <!-- Alert -->
      <v-flex xs12>
        <form-alert
          :type="alertText.type"
          :message="alertText.message"
          @close="closeFormAlert"
        ></form-alert>
      </v-flex>
      <!-- ./Alert -->

      <!-- Puzzle Etapas -->
      <v-layout row wrap>
        <v-flex xs12>
          <jns-step-puzzle
            :step-user-is="step"
            :steps="formSteps"
            @click="changeStep"
          ></jns-step-puzzle>
        </v-flex>
      </v-layout>
      <!-- ./Puzzle Etapas -->

      <!-- Etapas -->
      <v-layout id="apolice22" row wrap class="white_background no-gutter">
        <!-- ****Passo 1 - Tomador -->
        <tomador-passo1
          v-if="step == 1"
          :taker="taker"
          :step="step"
          :buscandoLimite="buscandoLimite"
          :unselectTaker="unselectTaker"
          :stepTitles="stepTitles"
          :product="product"
          :tipo_pessoa="tipo_pessoa"
          :msgErroBuscaLimite="msgErroBuscaLimite"
          :erroBuscaLimite="erroBuscaLimite"
          @setTaker="setTaker"
          @quitProposal="quitProposal"
        ></tomador-passo1>
        <!-- ./****Passo 1 - Tomador -->

        <!-- ****Passo 2 - Segurado -->
        <segurado-passo2
          v-if="step == 2"
          :taker="taker"
          :step="step"
          :unselectInsured="unselectInsured"
          :insured="insured"
          :lastInsuredSearchWasCNPJ="lastInsuredSearchWasCNPJ"
          :insuredResults="insuredResults"
          :showListToSelectInsured="showListToSelectInsured"
          :updateInsured="updateInsured"
          :updateInsuredFormValid="updateInsuredFormValid"
          :selectInsured="selectInsured"
          :insuredFormValid="insuredFormValid"
          @updateInsuredInfo="updateInsuredInfo"
          @selectInsuredType="selectInsuredType"
          @getInsuredByCNPJ="getInsuredByCNPJ"
          @getInsuredByCPF="getInsuredByCPF"
          @getInsuredByRazaoSocial="getInsuredByRazaoSocial"
        ></segurado-passo2>
        <!-- ./****Passo 2 - Segurado -->

        <!-- ****Passo 3 - Modalidades -->
        <modalidade-passo3
          v-if="step == 3"
          :step="step"
          :productGroups="productGroups"
          :selectedProductGroup="selectedProductGroup"
          :selectedGroupModalidades="selectedGroupModalidades"
          :selectedProduct="selectedProduct"
          :selectedGroupCoberturas="selectedGroupCoberturas"
          :selectedCoverages="selectedCoverages"
          :selectedGroupCoberturasAdicionais="selectedGroupCoberturasAdicionais"
          :selectedAdditionalCoverages="selectedAdditionalCoverages"
          @selectProductGroup="selectProductGroup"
          @selectProduct="selectProduct"
          @toggleCoverage="toggleCoverage"
          @toggleAdditionalCoverage="toggleAdditionalCoverage"
        ></modalidade-passo3>
        <!-- ./****Passo 3 - Modalidades -->

        <!-- ****Passo 4 - Apolice -->
        <apolice-passo4
          v-if="step == 4"
          ref="apoliceForm"
          :taker="taker"
          :step="step"
          :product="product"
          :inicioVigenciaMenu="inicioVigenciaMenu"
          :fimVigenciaMenu="fimVigenciaMenu"
          :buscandoLimite="buscandoLimite"
          :tipo_pessoa="tipo_pessoa"
          :TAGs="TAGs"
          :msgErroBuscaLimite="
            !taker.info.sublimites.length &&
            taker.info.status_nomeado != 'OUTRO_NOMEADO' &&
            me.company.classificacao == 'DIGITAL'
              ? 'Prezado Corretor, solicitamos que preencha o formulário, para verificar as condições de limites e taxas.'
              : msgErroBuscaLimite
          "
          :erroBuscaLimite="erroBuscaLimite"
          @getModalidadeNameByType="getModalidadeNameByType"
          @changeTagPlaceholderContent="changeTagPlaceholderContent"
          @getFimVigenciaMinimumDate="getFimVigenciaMinimumDate"
        ></apolice-passo4>
        <!-- ./****Passo 4 - Apolice -->

        <!-- ****Passo 5 - Premio e Comissao -->
        <premio-comissao
          v-if="step == 5"
          :idProposta="this.$route.params.propostaId"
          :idProduto="this.$route.params.produtoId"
          :proposta="proposta"
          @showQuestionamento="showQuestionamento"
          @emitProposalValues="definePolice"
          @desistir="desistir"
          @abrirModalTermosAceite="abrirModalTermosAceite"
          @emitGetMinuta="getMinuta"
        ></premio-comissao>
        <!-- ./****Passo 5 - Premio e Comissao -->
      </v-layout>
      <!-- ./Etapas -->
    </v-container>
    <!-- Container -->

    <!-- Footer -->

    <v-footer v-if="step < 5 && !isStep5Edit" class="proposta__footer">
      <v-btn class="jns-button width-auto white-button" id="desistir" @click="desistir()"
        >Desistir</v-btn
      >

      <v-spacer></v-spacer>

      <div v-if="step == 1 && cadastro_revisado === 'NAO_REVISADO'">
        <v-btn
          id="revisar_credito_sem_demanda"
          class="jns-button width-auto yellow-button"
          @click="redirecionarDocumentacaoTomador()"
          :hidden="true"
        >
          Revisar crédito sem demanda
        </v-btn>
      </div>

      <div>
        <v-btn
          class="jns-button width-auto yellow-button"
          id="emissao_tomador_btn_avancar"
          @click="goToNextStep(step)"
          :disabled="
            step != 4
              ? checkIfDisabled(step, stepCompleted)
              : desabilitaSolicitarAnalise()
          "
        >
          {{
            !tomadorAnaliseCredito &&
            step == 4 &&
            !compareWithToday(this.taker.info.data_validade_limite) &&
            me.company.classificacao == "DIGITAL"
              ? "Preencher formulário"
              : "Avançar"
          }}
          <v-icon>arrow_right_alt</v-icon>
        </v-btn>
      </div>
    </v-footer>

    <!-- *************MODAIS -->

    <v-dialog v-model="successModal" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Proposta salva com sucesso</h2>
        <p class="pt-2 pb-4" v-html="successReturn"></p>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="successReturnClick()"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <v-dialog v-model="semProdutos" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Aviso</h2>
        <p class="pt-2 pb-4">
          O tomador não possui produto habilitado para o tipo de segurado
          selecionado.
        </p>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="semProdutosClick()"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <v-dialog v-model="validateLimitModal" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Limite indisponível</h2>
        <p class="pt-2 pb-4">
          O tomador não possui limite de crédito disponível para esta operação!
        </p>
        <v-layout row wrap>
          <v-flex xs4 offset-xs8>
            <button
              class="button jns-button yellow-button"
              @click="validateLimitModalClick()"
            >
              OK
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <!-- Modal desistência passo 5-->
    <v-dialog v-model="modalDesistir" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Informe o motivo da desistência</h2>
        <v-layout row wrap>
          <v-flex xs12>
            <v-select
              class="form-select-box"
              label="Motivo"
              v-model="id_motivo"
              placeholder="Motivo "
              :rules="[rules.obrigatorio]"
              :items="motivos"
              :item-value="'id'"
              :item-text="'descricao'"
            ></v-select>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              class="jns-input"
              label="Observações"
              v-model="observacao"
              placeholder=" "
            ></v-textarea>
          </v-flex>

          <v-flex xs6>
            <v-btn
              class="button jns-button yellow-button"
              @click="quitProposal()"
              >OK</v-btn
            >
          </v-flex>
          <v-flex xs6>
            <v-btn
              class="button jns-button yellow-button"
              @click="modalDesistir = false"
              >Cancelar</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
    <!-- ./Modal desistência -->

    <!-- Modal desistência -->
    <v-dialog v-model="confirmQuitModal" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Certeza que deseja desistir?</h2>
        <p class="pt-2 pb-4">Todos os dados de proposta serão perdidos</p>
        <v-layout row wrap>
          <v-flex xs4></v-flex>
          <v-flex xs4>
            <v-btn
              class="button jns-button yellow-button"
              @click="quitProposal()"
              >OK</v-btn
            >
          </v-flex>
          <v-flex xs4>
            <v-btn
              class="button jns-button yellow-button"
              @click="confirmQuitModal = false"
              >Cancelar</v-btn
            >
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>
    <!-- ./Modal desistência -->

    <v-dialog v-model="confirmParticipantDelete" :max-width="'640'">
      <base-modal>
        <h2 class="headline">Certeza que deseja deletar esse participante?</h2>
        <v-layout row wrap>
          <v-flex xs4>
            <button
              class="button jns-button yellow-button"
              @click="
                takerParticipants.splice(participantToBeDeleted, 1);
                participantToBeDeleted = false;
                confirmParticipantDelete = false;
              "
            >
              OK
            </button>
          </v-flex>
          <v-flex xs4>
            <button
              class="button jns-button white-button"
              @click="
                participantToBeDeleted = false;
                confirmParticipantDelete = false;
              "
            >
              Cancelar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <v-dialog
      v-model="participanteModal"
      max-width="'640'"
      v-if="reloadParticipanteModal"
    >
      <adicionar-participante-modal
        @close="participanteModal = false"
        @addParticipant="addNewParticipant"
      />
    </v-dialog>

    <!-- Modal de questionamento -->
    <questionamento-component
      :questionamentoDialog="dialogQuestionamento"
      :questionamentoSucessoDialog="questionamentoSucessoModal"
      :mostraCampoUpload="mostraCampoUploadQuestionamento"
      @send="sendQuestionamento"
      @close="dialogQuestionamento = false"
    />

    <!-- Modal CPF do Segurado -->
    <v-dialog v-model="modalNome" :max-width="'640'" persistent>
      <base-modal>
        <h2 class="headline">Pessoa Física (Depósito Recursal)</h2>

        <v-form ref="novoSegurado" lazy-validation>
          <v-layout row wrap mt-3>
            <v-flex xs12>
              <v-text-field
                class="jns-input"
                label="Informe o nome"
                v-model="insuredName"
                placeholder="Nome do segurado"
                :rules="[rules.obrigatorio]"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 pt-0>
              <h3>Endereço</h3>
            </v-flex>
          </v-layout>

          <endereco-component
            :endereco="insuredAddress"
            :lograduroCompacto="false"
            :numberRequired="false"
            ref="formEnderecoComponent"
          ></endereco-component>
        </v-form>

        <v-layout row wrap>
          <v-flex xs6>
            <button
              class="jns-button ml-0 white-button"
              @click="modalNome = false"
            >
              Cancelar
            </button>
          </v-flex>
          <v-flex xs6>
            <button
              class="button jns-button yellow-button ml-0"
              @click="salvarSegurado()"
            >
              Salvar
            </button>
          </v-flex>
        </v-layout>
      </base-modal>
    </v-dialog>

    <!-- Modal Processando Solicitação -->
    <v-dialog v-model="dialogProcessandoSolicitacao" persistent max-width="700">
      <base-modal>
        <processo-solicitacao-proposta
          :processSteps="this.processSteps"
          :processInExecution="this.processInExecution"
          :message="this.actualProcessStepErrorMessage"
          :processSuccess="this.processSuccess"
          :mostraBotaoAvancar="this.id_proposta && this.id_produto"
          :statusProposta="proposta.s"
          @goto="goto"
        ></processo-solicitacao-proposta>
      </base-modal>
    </v-dialog>

    <!-- Modal termos de aceite para emitir proposta -->
    <v-dialog
      v-model="dialogEmitirProposta"
      scrollable
      persistent
      max-height="600px"
      min-height="500px"
      max-width="800px"
    >
      <v-card class="px-3 pt-3">
        <v-card-text>
          <h2 class="headline">Termo de Aceite</h2>
          <div class="pt-2 pb-4">
            <span>Leia os termos para solicitar a emissão da proposta.</span>
          </div>
          <p v-html="termos"></p>
        </v-card-text>
        <v-card-actions>
          <v-checkbox v-model="aceitaTermos" color="blue">
            <div slot="label" id="termo_acordo">
              Declaro que li e estou de acordo com os termos acima
            </div>
          </v-checkbox>
          <v-layout row wrap>
            <v-flex xs6>
              <v-btn
                style="width: 130px"
                class="jns-button width-auto white-button"
                outline
                round
                @click="dialogEmitirProposta = false"
                >Cancelar</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn
                id="solicitar_apolice"
                style="width: 150px"
                class="jns-button width-auto yellow-button"
                :dark="aceitaTermos"
                round
                :disabled="!aceitaTermos"
                @click="emitirApolice"
                >Solicitar</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Modal termos de aceite para emitir proposta -->

    <!-- Modal para emitir proposta -->
    <v-dialog
      persistent
      v-model="dialogEmitindoProposta"
      max-height="600px"
      min-height="500px"
      max-width="500px"
    >
      <v-card class="px-3 pt-3">
        <v-card-text>
          <div
            v-if="erroResponse.status == 0 && propostaEmitida == false"
            class="my-3"
          >
            <img
              :src="require('../../../assets/animations/loading-yellow.gif')"
              class="loading-animation"
              alt
            />
            <h2 class="headline">Solicitando emissão da proposta</h2>
            <p class="pt-2 pb-4">
              Enviando os dados para emissão da proposta. Por favor, não saia da
              tela...
            </p>
          </div>
          <div v-else-if="propostaEmitida == true" class="my-5">
            <h2 class="headline">Apólice emitida</h2>
            <p class="pt-2 pb-4">
              A proposta número {{ id_proposta }} foi emitida com sucesso!
            </p>
          </div>
          <!--- reemissão de proposta com alteração de vigência -->
          <div v-else-if="erroResponse.data.code == 4051" class="mb-3">
            <h2 class="headline">{{ erroResponse.data.title }}</h2>
            <div class="pt-2 pb-4">{{ erroResponse.data.message }}</div>
            <!-- <p class="pt-2 pb-4">{{erroResponse.data.message}}</p> -->
          </div>

          <div v-else class="mb-3">
            <h2 class="headline">{{ erroResponse.data.title }}</h2>
            <p class="pt-2 pb-4">{{ erroResponse.data.message }}</p>
            <p v-if="erroResponse.data.code == 4055" class="pt-2 pb-4">
              <a :href="urlCliqueAqui">Clique aqui</a>
            </p>
          </div>

          <v-layout row wrap v-if="erroResponse.data.details != null">
            <v-flex xs4 class="pt-2 pb-4">
              <p
                class="see-details mb-0"
                @click="toggleShowDetails()"
                v-if="erroResponse.data.details != 'Sem detalhes'"
              >
                Ver detalhes
                <v-btn icon>
                  <v-icon v-if="showDetails">keyboard_arrow_up</v-icon>
                  <v-icon v-if="!showDetails">keyboard_arrow_down</v-icon>
                </v-btn>
              </p>
            </v-flex>
            <v-fade-transition>
              <v-flex xs12 v-if="showDetails">
                <v-textarea
                  class="details"
                  outline
                  readonly
                  :value="erroResponse.data.details"
                ></v-textarea>
              </v-flex>
            </v-fade-transition>
          </v-layout>
        </v-card-text>

        <v-card-actions v-if="erroResponse.mostraBtnAcao">
          <v-layout row wrap>
            <v-flex xs6>
              <v-btn
                style="width: 95%"
                class="jns-button width-auto yellow-button"
                round
                @click="goto('timeline')"
                >Detalhes da apólice</v-btn
              >
            </v-flex>

            <v-flex xs6>
              <v-btn
                style="width: 95%"
                class="jns-button width-auto yellow-button"
                round
                @click="goto('mesa')"
                >Mesa de Trabalho</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-actions>
        <v-card-actions v-if="erroResponse.data.code == 4051">
          <v-layout row wrap>
            <v-flex xs6>
              <v-btn
                style="width: 95%"
                class="jns-button width-auto yellow-button"
                round
                @click="emitirApolice({ alterarVigencia: true })"
                >Aceito</v-btn
              >
            </v-flex>
            <v-flex xs6>
              <v-btn
                style="width: 95%"
                class="jns-button width-auto yellow-button"
                round
                @click="goto('mesa')"
                >Cancelar</v-btn
              >
            </v-flex>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ./Modal para emitir proposta -->

    <v-dialog fullscreen hide-overlay v-model="dialogAnaliseCredito">
      <v-card>
        <v-container grid-list-xl class="no-padding">
          <v-card-title class="ml-0 pl-0 pt-5 pb-4">
            <h2>Análise de Crédito</h2>
          </v-card-title>

          <processo-analise-credito
            v-if="dialogAnaliseCredito"
            :item="taker.tomador_credito ? taker.tomador_credito : taker.info"
            :pendencias="pendencias"
            :route="'POST_PRE_ANALISE_CREDITO'"
            :slug="slug"
            @fecharAnaliseCreditoModal="fecharAnaliseCreditoModal"
            @solicitarLimites="solicitarLimitesAnaliseCredito"
          ></processo-analise-credito>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog fullscreen hide-overlay v-model="dialogResumoProposta">
      <v-card>
        <v-container grid-list-xl class="no-padding">
          <v-card-title class="ml-0 pl-0 pt-5 pb-4">
            <h2>Resumo da Proposta</h2>
          </v-card-title>

          <proposta-expandida-informacoes
            v-if="resumoProposta && resumoProposta.tomador"
            :tomador="resumoProposta.tomador"
            :segurado="resumoProposta.segurado"
            :modalidades="resumoProposta.modalidade"
            :coberturas="resumoProposta.coberturas"
            :objeto="resumoProposta.objeto"
          />

          <v-card-actions class="pt-4 pb-3">
            <v-btn
              class="jns-button width-auto white-button"
              id="voltar"
              @click="closeResumoProposta()"
              >Voltar</v-btn
            >
            <v-spacer></v-spacer>
            <v-btn
            id="emissao_solicitar_analise_resumo"
              class="jns-button width-auto yellow-button"
              @click="dialogFollowUp = true"
            >
              Solicitar Análise
              <v-icon>arrow_right_alt</v-icon>
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      persistent
      max-height="600px"
      min-height="500px"
      max-width="640px"
      v-model="dialogFollowUp"
    >
      <v-card class="box-card-follow-up">
        <v-container grid-list-xl>
          <v-card-title class="box-card-follow-up-title">
            <h2>
              Prezado corretor, por favor, preencha o e-mail para contato.
            </h2>
          </v-card-title>

          <v-form v-model="validFollowUp">
            <v-text-field
              id="emissao_input_email"
              class="jns-input"
              v-model="inputEmail"
              label="Email"
              :rules="[rules.email]"
              placeholder=" "
              v-on:keyup.enter.prevent="keyUpEnterSetEmailFollowUp()"
            ></v-text-field>
          </v-form>

          <v-card-actions class="box-card-follow-up-buttons">
            <v-btn
              class="jns-button white-button"
              @click="dialogFollowUp = false"
              >Voltar</v-btn
            >

            <v-btn
              id="emissao_solicitar_analise_email"
              class="jns-button yellow-button"
              @click.prevent="setEmailFollowUp()"
              :disabled="!validFollowUp"
            >
              Solicitar Análise
              <v-icon>arrow_right_alt</v-icon>
            </v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-content>
</template>

<script lang="js">
import { isValidCnpj, isValidCpf, isCNPJ, capitalize } from "@/libs/utils";
import ViewMixin from "@/mixins/ViewMixin";
import TomadorPasso1 from "./Passos/Tomador";
import SeguradoPasso2 from "./Passos/Segurado";
import ModalidadePasso3 from "./Passos/Modalidade";
import ApolicePasso4 from "./Passos/Apolice";
import PremioComissao from "./Passos/PremioComissao";
import { mapActions } from "vuex";
import axios from "axios";
import config from "@/../config";

export default {
  name: "NovaProposta",
  props: {
    toStep5: {
      type: Number,
      default: 5,
    },
  },
  //directives: { money: VMoney },
  components: {
    TomadorPasso1,
    SeguradoPasso2,
    ModalidadePasso3,
    ApolicePasso4,
    PremioComissao,
  },
  mixins: [ViewMixin],
  data(){return {
      rules: {
        obrigatorio: (v) =>
          !!v || this.disabledValidation || "Campo obrigatório",
      email: (v) =>
        !v ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
        "E-mail inválido"
          },
    insuredAddress:{},
    formSteps: [
      { id: 1, number: "01", text: "Dados do Tomador" },
      { id: 2, number: "02", text: "Dados do Segurado" },
      { id: 3, number: "03", text: "Modalidade do Seguro" },
      { id: 4, number: "04", text: "Dados da Apólice" },
      { id: 5, number: "05", text: "Prêmio e Comissão" },
    ],
    cnpjTomador: "",
    emailFollowUp: '',
    tomadorAnaliseCredito: undefined,
    development: true, //FIXME: COLOCAR FALSE AO ENVIAR PARA HOM/PRD
    modalNome: false,
    insuredName: "",
    idTomador: 0,
    cadastro_revisado: "",
    proposta: false,
    erroBuscaLimite: false,
    erroBuscaLimiteRequest: false,
    bloqueiaErroBuscaLimite: false,
    msgErroBuscaLimite: "",
    limitesAgrupadosPorModalidade: {},
    buscandoLimite: false,
    buscandoLimiteModalidades: false,
    step: 1,
    lastTakerSearchWasCNPJ: false,
    lastInsuredSearchWasCNPJ: false,
    id_proposta: false,
    id_produto: false,
    tabDetalharProposta: "",
    limits: false,
    drawer: null,
    aceitaTermos: false,
    dialogEmitirProposta: false,
    limitsMenu: false,
    successModal: false,
    validateLimitModal: false,
    successReturn: false,
    participantToBeDeleted: false,
    confirmParticipantDelete: false,
    participanteModal: false,
    loadingFromBackendModal: false,
    confirmQuitModal: false,
    modalDesistir: false,
    dialogResumoProposta: false,
    dialogFollowUp: false,
    validFollowUp: false,
    inputEmail: '',
    dialogAnaliseCredito: false,
    stepCompleted: 0,
    selectedProductGroup: 0,
    selectedProduct: false,
    selectedAdditionalCoverages: [],
    selectedCoverages: [],
    productGroups: {},
    resumoProposta: {},
    showSelectTaker: false,
    showListToSelectInsured: false,
    completedTaker: false,
    taker: {
      // cnpj: "21202303000167",
      // cnpj: '14444367000109',
      stepType: 1,
    },
    takerFormValid: false,
    takerParticipants: [],
    takerResults: [],
    insuredResults: [],
    TAGs: [],
    foreignTaker: {},
    tagMenu: [],
    inicioVigenciaMenu: [],
    fimVigenciaMenu: [],
    insured: {
      // cnpj: "28304760000101",
      stepType: 1,
    },
    prize: {},
    insuredFormValid: false,
    product: [],
    stepTitles: [
      "Tomador",
      "Segurado",
      "Modalidade",
      "Informações de Garantia",
      "Prêmio",
    ],
    reloadParticipanteModal: true,
    dialogQuestionamento: false,
    questionamento: {
      body: {
        observacoes: "",
        documentos: [],
      },
    },
    isStep5Edit: false,
    mostraCampoUploadQuestionamento: false,
    mostraBtnQuestionamento: false,
    documentosData: [],
    questionamentoSucessoModal: false,
    id_motivo: 0,
    observacao: "",
    termos: "",
    motivos: [],
    toolTipLimitesIndisponiveis: false,
    toolTipBuscandoLimites: false,
    tipo_pessoa: "",
    semProdutos: false,
    idTomadorPesquisaLimites: 0,
    parameters: [],
    parametersTomador: {},
    dialogProcessandoSolicitacao: false,
    dialogEmitindoProposta: false,
    processInExecution: false,
    processSuccess: false,
    actualProcessStepErrorMessage: "",
    apolice: null,
    statusProposta: "",
    erroResponse: {
      status: 0,
      data: {},
      mostraBtnAcao: false,
    },
    propostaEmitida: false,
    urlCliqueAqui: "",
    processSteps: [
      {
        step: 1,
        display: true,
        status: "pending",
        text: "Salvando a proposta...",
        success_text: "Proposta n° arg criada com sucesso.",
        error_text: "Não foi possivel salvar a proposta.",
        details: null,
      },
      {
        step: 2,
        display: false,
        status: "pending",
        text: "Aprovação automática de cŕedito...",
        success_text: "Crédito aprovado automaticamente.",
        error_text: "Aprovação automática de crédito.",
        details: {
          recusado: "Proposta recusada pela análise automática de crédito.",
          corretor:
            "Prezado Corretor, o tomador passará por análise de crédito manual, favor prosseguir com anexo de documentação solicitada. Em breve retornamos com as condições de limites e taxas.",
          seguradora:
            "Prezado Corretor, o tomador passará por análise de crédito manual. Em breve retornamos com as condições de limites e taxas.",
        },
      },
      {
        step: 3,
        display: false,
        status: "pending",
        text: "Aprovação automática de subscrição...",
        success_text: "Subscrição aprovada automaticamente.",
        error_text: "Aprovação automática de subscrição.",
        details: {
          recusado: "Proposta recusada pela análise automática de subscrição.",
          corretor:
            "Necessário fornecer documentação complementar do Risco a ser garantido, e a proposta será direcionada para análise de subscrição.",
          seguradora: "A proposta será direcionada para análise de subscrição.",
        },
      },
      {
        step: 4,
        display: false,
        status: "pending",
        text: "Aprovação automática de resseguro...",
        success_text: "Resseguro aprovado automaticamente.",
        error_text: "Aprovação automática de resseguro.",
        details: {
          recusado: "Proposta recusada pela análise automática de resseguro.",
          corretor:
            "Necessário fornecer documentação complementar do Risco a ser garantido, e a proposta será direcionada para análise de resseguro.",
          seguradora: "A proposta será direcionada para análise de resseguro.",
        },
      },
    ],
    showDetails: false,
    isProcessing: false,
  }},
  computed: {
    pendencias() {
      let temPendencias = false;
      let maxImportanciaSegurada = null;

      if (
        this.productGroups[this.selectedProductGroup].id_grupo == "TRADICIONAL"
      )
        maxImportanciaSegurada = this.parametersTomador.valor_limite_is
          .tradicionais;
      else if (
        this.productGroups[this.selectedProductGroup].id_grupo == "FINANPRIVADO"
      )
        maxImportanciaSegurada = this.parametersTomador.valor_limite_is
          .pagamentos;
      else
        maxImportanciaSegurada = this.parametersTomador.valor_limite_is
          .judiciais;

      if (
        this.product &&
        this.product.coberturas &&
        this.product.coberturas.length
      )
        this.product.coberturas.forEach((produto) => {
          if (produto.importancia_segurada) {
            let importancia_segurada =
              typeof produto.importancia_segurada == "string"
                ? parseFloat(
                    produto.importancia_segurada
                      .replace("R$ ", "")
                      .replace(/\./g, "")
                      .replace(",", ".")
                  )
                : produto.importancia_segurada;

            if (maxImportanciaSegurada < importancia_segurada)
              temPendencias = true;
          }
        });
      return temPendencias ? this.parametersTomador.pendencias : [];
    },

    slug() {
      if (this.selectedProductGroup)
        return this.productGroups[this.selectedProductGroup].id_grupo;

      return false;
    },

    me() {
      return localStorage ? JSON.parse(localStorage.getItem("me")) : {};
    },

    selectedGroupModalidades() {
      if (this.productGroups.length > 0) {
        if (this.productGroups[this.selectedProductGroup] != null)
          return this.productGroups[this.selectedProductGroup].modalidades;
        else return [];
      } else return [];
    },
    selectedGroupCoberturasAdicionais() {
      let grupos = this.selectedGroupModalidades.find(
        (item) => item.id == this.selectedProduct
      );

      if (grupos == null) return [];
      else {
        if (grupos != null) return grupos.coberturas_adicionais;
        else return [];
      }
    },
    selectedGroupCoberturas() {
      let grupoCoberturas = this.selectedGroupModalidades.find(
        (item) => item.id == this.selectedProduct
      );

      if (grupoCoberturas) {
        return grupoCoberturas.coberturas_corretivas;
      } else return [];
    },
    documentoSubscricaoObrigatorio() {
      if (this.parameters != null) {
        if (this.parameters.conteudo != null) {
          if (
            this.parameters.conteudo.importancia_segurada_arquivo_subscricao !=
            null
          ) {
            let importancia = this.moneyToFloat(
              this.product.coberturas[0].importancia_segurada
            );

            if (
              importancia >
              this.parameters.conteudo.importancia_segurada_arquivo_subscricao
            ) {
              return true;
            }
          }
        }
      }
      return false;
    },
  },
  methods: {
    ...mapActions(["POST_QUESTIONAMENTO"]),

    moneyToFloat(value) {
      try {
        return parseFloat(value.replace(/[^0-9,-]+/g, "").replace(",", "."));
      } catch (e) {
        return 0;
      }
    },

    obterQueryParam(param) {
      const query = window.location.search.substring(1)
      const params = new URLSearchParams(query)
      return params.get(param)
    },

    definePolice(postData) {
      this.apolice = postData;
    },

    defineUrlCliqueAqui(proposta) {
      if (this.proposta.tomador != null)
        this.urlCliqueAqui = `#/tomadores/${this.proposta.tomador.cnpj_cpf}#contra-garantia`;
      else this.urlCliqueAqui = `#`;
    },

    toggleShowDetails() {
      this.showDetails = !this.showDetails;
    },

    resetErroResponse() {
      this.erroResponse = {
        status: 0,
        data: {},
        mostraBtnAcao: false,
      };
    },

    emitirApolice(options = {}) {
      this.dialogEmitindoProposta = true;
      this.dialogEmitirProposta = false;

      if (options.alterarVigencia) {
        this.apolice.aceite_alterar_vigencia = true;
        this.resetErroResponse();
      }

      if (this.apolice != null) {
        const axio = axios.create({
          baseURL: config.apiUrl + config.versoes[0],
        });

        this.id_proposta = this.proposta.id;
        this.id_produto = this.proposta.id_produto;

        axio
          .post("/emissao", this.apolice)
          .then((response) => {
            const rd = response.data;
            this.postResponse = rd;

            if (response.status == 200 && response.data.id_apolice) {
              this.propostaEmitida = true;
            } else this.propostaEmitida = false;
            this.erroResponse.mostraBtnAcao = true;
          })
          .catch((e) => {
            let mostraBtnAcao = e.response.data.code != 4051;
            this.propostaEmitida = false;
            this.erroResponse = {
              status: e.response.status,
              data: e.response.data,
              mostraBtnAcao,
            };
          });
      }
    },

    abrirModalTermosAceite() {
      this.dialogEmitirProposta = true;
      this.aceitaTermos = false;
    },

    setSpaces(text) {
      while (text.includes(" ")) {
        text = text.replaceAll(" ", "_");
      }
      return text;
    },

    loadTermos() {
      this.termos = `
<strong>(i)</strong> Se aplicável, declaro que o contrato de prestação de serviços para o qual pretendo obter apólice de seguro garantia não possui regime de dedicação exclusiva de mão de obra, sob pena de nulidade da presente proposta e respectiva apólice e/ou endosso em apólice, se emitidos.
<br/><br/>
<strong>(ii)</strong> Declaro também que, em observância as normas regulamentares vigentes, comuniquei ao cliente o montante da minha remuneração pela intermediação deste contrato de seguro.
<br/><br/>
<strong>(iii)</strong> Por fim, declaro que as informações e documentos fornecidos para o exame desta proposta de seguros, por meio deste portal, representam os elementos necessários para a análise do risco por parte da Seguradora, bem como são verdadeiros e representam as reais condições do Contrato Principal, ou similar, a ser garantido. O Tomador, por meio próprio ou por seu Corretor de Seguros, declara, ainda, expressamente, ter lido e compreendido a extensão e objeto do seguro e que está de acordo com as condições estabelecidas, incluindo as Condições Contratuais da apólice e/ou endosso em apólice.
    `;
    },

    async sendQuentionamentoObservacao(observacao){
      try {
        await this.POST_QUESTIONAMENTO({
          observacoes: observacao || "",
          propostaId: +this.$route.params.propostaId,
          produtoId: +this.$route.params.produtoId,
        });
        this.dialogQuestionamento = false;
        this.questionamentoSucessoModal = true;
      } catch (e) {
        this.defaultHandlerError(e);
      } finally {}
    },

    //Método novo
    async sendQuentionamentoDocument(documentos){
      let model = [];
      documentos.forEach((element) => {
        if (element.arquivos && element.arquivos.length) {
          var arquivos = [];
          element.arquivos.forEach((arquivo) => {
            arquivos.push({
              nome_em_disco: arquivo.nome,
              arquivo: arquivo.arquivo,
            });
          });

          model.push({
            id: 56,
            nome: "Outros Documentos",
            arquivos: arquivos,
          });
        }
        model = { documentos: model }
      });

      try {
        console.warn('Enviando arquivos..');
        await this.$store.dispatch("POST_DOCUMENTOS_QUESTIONAMENTO", {
          propostaId: this.$route.params.propostaId,
          produtoId: this.$route.params.produtoId,
          model: model,
        });
      }catch (e){
        let options = {
          code: null,
          details: null,
          message: "Não foi possível finalizar a gravação de documentos.",
          title: "Falha ao gravar documentos",
        };
        this.setErrorModal(options)
      }finally {}
    },

    async sendQuestionamento(data) {

      if (data == "") {
        this.hideLoadingAskWait();

        let options = {
          code: null,
          details: null,
          message: "Favor informar uma observação.",
          title: "Aviso",
        };
        this.setErrorModal(options);

        return;
      }

      if(data.documentos && data.observacao){
        this.showLoadingAskWait();
        Promise.all([this.sendQuentionamentoDocument(data.documentos), this.sendQuentionamentoObservacao(data.observacao)]).then(()=> {
          this.hideLoadingAskWait();
        });
      }else {
        if(data){
          this.showLoadingAskWait();
          Promise.all([this.sendQuentionamentoObservacao(data)]).then(() => {
            this.hideLoadingAskWait();
          });
        }else {
          this.showLoadingAskWait();
          Promise.all([this.sendQuentionamentoObservacao("teste observacao web")]).then(() => {
            this.hideLoadingAskWait();
          });
        }
      }
    }, // . sendQuestionamento

    successReturnClick() {
      this.successModal = false;
      this.$router.push({ path: "/mesa-de-trabalho" });
    },

    validateLimitModalClick() {
      this.validateLimitModal = false;
    },

    getFimVigenciaMinimumDate(product) {
      return new Date(product.inicio_vigencia) > new Date()
        ? product.inicio_vigencia
        : new Date().toISOString().slice(0, 10);
    },

    async quitProposal() {
      let propostaId = this.$route.params.propostaId;
      let produtoId = this.$route.params.produtoId;

      if (produtoId && propostaId) {
        let payload = {
          id_proposta: propostaId,
          id_produto: produtoId,
        };

        if (this.step == 5) {
          if (this.id_motivo > 0) payload.id_motivo = this.id_motivo;
          if (this.observacao != "") payload.observacao = this.observacao;
        }

        this.showLoadingAskWait();
        try {
          payload.status = "CANCELADA";
          await this.$store.dispatch("QUIT_PROPOSAL", payload);
        } catch (e) {
          this.defaultHandlerError(e);
          return;
        } finally {
          this.hideLoadingAskWait();
        }
      }
      this.$router.push({ path: "/mesa-de-trabalho" });
    },

    updateInsured(insured) {
      this.insured = Object.assign(this.insured, insured);
    },

    updateInsuredFormValid(formValid) {
      this.insuredFormValid = formValid;
    },

    showMsgOpUnavailable() {
      // Opções indisponíveis!
      let options = {
        code: null,
        details: null,
        message:
          "Para essa operação entre em contato com nossa equipe comercial.",
        title: "Operação indisponível.",
      };
      this.setErrorModal(options);
    },

    selectTakerType(event) {
      let value = event.currentTarget.value;

      if (parseInt(value) > 1) {
        this.showMsgOpUnavailable();
        return;
      }

      this.taker = {};
      this.stepCompleted = 0;
      this.taker.stepType = value;
      this.takerParticipants = [];
      this.takerResults = [];
      this.showSelectTaker = false;
      this.$forceUpdate();
    },

    selectInsuredType(event) {
      let value = event.currentTarget.value;

      if (parseInt(value) > 2) {
        this.showMsgOpUnavailable();
        return;
      }

      this.$set(this.insured, "cnpj", "");
      this.insured = {};
      this.insured.stepType = value;
      this.insuredResults = [];
      this.showListToSelectInsured = false;
      this.$forceUpdate();
    },

    selectProductGroup(event, id_grupo) {
      let value = event.currentTarget.value;
      this.selectedAdditionalCoverages = [];
      this.selectedCoverages = [];
      this.selectedProduct = false;
      this.selectedProductGroup = value;
      this.id_grupo = id_grupo;

      this.checkIfDisabled(this.step, this.stepCompleted);

      this.$forceUpdate();
    },

    selectProduct(event) {
      let value = event.currentTarget.value;
      this.selectedAdditionalCoverages = [];
      this.selectedCoverages = [];
      this.selectedProduct = value;
      this.stepCompleted = 3;
      this.$forceUpdate();
    },

    toggleAdditionalCoverage(event) {
      let value = event.currentTarget.value;

      if (this.selectedAdditionalCoverages.indexOf(value) == -1) {
        this.selectedAdditionalCoverages.push(value);
      } else {
        let index = this.selectedAdditionalCoverages.indexOf(value);
        this.selectedAdditionalCoverages.splice(index, 1);
      }
      this.$forceUpdate();
    },

    toggleCoverage(event) {
      let value = event.currentTarget.value;
      let index;
      if (this.selectedCoverages.indexOf(value) == -1) {
        this.selectedCoverages.push(value);
      } else {
        index = this.selectedCoverages.indexOf(value);
        this.selectedCoverages.splice(index, 1);
      }

      this.$forceUpdate();
    },

    changeStep({ index: step }) {
      if (this.step > step && this.step <= 4) {
        this.step = ++step;
        this.resetScroll();
      }
      this.resetScroll();
    },

    resetScroll() {
      document.querySelectorAll(".white_background")[0].scrollTo(0, 0);
      this.$forceUpdate();
    },

    groupBy(array, key) {
      if (!array.length) {
        return;
      }
      const result = {};
      array.forEach((item) => {
        if (!result[item[key]]) {
          result[item[key]] = [];
        }
        result[item[key]].push(item);
      });
      return result;
    },

    modalTomadorInativo() {
      let options = {
        code: null,
        details: null,
        message:
          "Desculpe, este tomador não é compatível com a política da JNS Seguradora.",
        title: "Problema ao recuperar os dados tomador.",
      };
      this.setErrorModal(options);
    },

    compareWithToday(date) {
      if (date == null || date == "") return false;

      try {
        let today = new Date();
        let compareYear = date.substring(0, 4);
        let compareMonth = date.substring(5, 7);
        let compareDay = date.substring(8, 10);
        let compareDate = new Date(
          compareYear,
          parseInt(compareMonth) - 1,
          compareDay
        );

        return compareDate > today;
      } catch (error) {
        return false;
      }
    },

    /* Busca do Tomador por CNPJ e busca dos limites */
    async setTaker(data) {
      this.tomadorAnaliseCredito = undefined;
      this.erroBuscaLimite = false;
      this.stepCompleted = 1;
      this.cnpjTomador = data[0].cnpj_cpf

      // Se a data for maior que a data de hoje, continua a execução, caso contrário valida a situação
      if (this.compareWithToday(data[0].data_validade_limite)) {
        if (!data[0].situacao_ativo || !data[0].ativo) {
          this.modalTomadorInativo();
          this.checkIfDisabled(this.step, this.stepCompleted);
          return;
        }
      }

      this.alertText = this.handleAlertText2(
        this.getTakerAlertMessage(data[0])
      );

      // prevenir se necessario, toda vez que alguma pesquisa acontecer
      if (data[0].status_nomeado == "OUTRO_NOMEADO") this.stepCompleted = 0;

      await this.$nextTick();
      this.taker.info = data[0];

      if (data.tomador_credito)
        this.taker.tomador_credito = data.tomador_credito;
      else this.taker.tomador_credito = null;

      // Validar se pesquisa do tomador retornou limites
      if (
        !this.taker.info.sublimites.length &&
        this.taker.info.status_nomeado != "OUTRO_NOMEADO" &&
        this.me.company.classificacao != "DIGITAL"
      ) {
        // buscar sublimites para exibir na tabela
        this.getLimite();
      } else if (
        !this.compareWithToday(data[0].data_validade_limite) &&
        this.taker.info.status_nomeado != "OUTRO_NOMEADO" &&
        this.me.company.classificacao == "DIGITAL"
      ) {
        this.msgErroBuscaLimite =
          "Prezado Corretor, solicitamos que prossiga no preenchimento da proposta, para verificar as condições de limites e taxas.";
        this.erroBuscaLimite = true;
      } else if (this.taker.info.status_nomeado == "OUTRO_NOMEADO") {
        this.msgErroBuscaLimite =
          "Não foi possível obter os limites pois o tomador possui outro corretor nomeado";
        this.erroBuscaLimite = true;
      } else if (
        ["MIDDLE_PLUS", "CORPORATE", "CORPORATE_PLUS"].includes(
          this.taker.info.faturamento
        ) &&
        this.taker.info.cadastro_revisado != "REVISADO" &&
        (!this.taker.info.grupos_credito ||
          !this.taker.info.grupos_credito.length)
      ) {
        this.msgErroBuscaLimite =
          "Prezado Corretor, o tomador passará por análise de crédito manual. Prossiga com a inserção da proposta.";
        this.erroBuscaLimite = true;
      } else {
        this.limitesAgrupadosPorModalidade = this.groupBy(
          this.taker.info.sublimites,
          "modalidade"
        );
        this.cadastro_revisado = this.taker.info.cadastro_revisado
        await this.$nextTick();
        this.$forceUpdate();
      }
    },
    async getLimite() {
      this.buscandoLimite = true;
      this.erroBuscaLimite = false;
      this.erroBuscaLimiteRequest = false;
      let limitsInfo;

      try {
        limitsInfo = await this.$store.dispatch("GET_TAKER_LIMITES", {
          id: this.taker.info.id,
        });

        this.taker.info = limitsInfo;
        this.idTomadorPesquisaLimites = limitsInfo.id;
        this.buscandoLimite = false;

        if (this.taker.info.situacao_ativo && this.taker.info.ativo) {
          if (
            ["MIDDLE_PLUS", "CORPORATE", "CORPORATE_PLUS"].includes(
              this.taker.info.faturamento
            ) &&
            this.taker.info.cadastro_revisado != "REVISADO" &&
            (!this.taker.info.grupos_credito ||
              !this.taker.info.grupos_credito.length)
          ) {
            this.msgErroBuscaLimite =
              "Prezado Corretor, o tomador passará por análise de crédito manual. Prossiga com a inserção da proposta.";
            this.erroBuscaLimite = true;
          }
        } else {
          this.handlerErrors({
            data: {
              message: this.getTakerAlertMessage(this.taker.info),
              title: "Problema ao recuperar os dados tomador.",
            },
            response: { status: 409 },
          });
        }
      } catch (e) {
        if (e.data) {
          if (e.data.code == "4054") {
            this.msgErroBuscaLimite = this.handlerErrors(e);
          } else {
            if (e.code) {
              if (e.code == "4054") {
                this.msgErroBuscaLimite = this.handlerErrors(e);
              }
            } else this.msgErroBuscaLimite = this.handlerErrors(e);
          }
        } else this.msgErroBuscaLimite = this.handlerErrors(e);

        this.idTomadorPesquisaLimites = 0;
        this.erroBuscaLimite = true;
        this.erroBuscaLimiteRequest = true;
        this.buscandoLimite = false;

        // Sempre retornar ao passo 1 se der erro
      } finally {
        this.bloqueiaErroBuscaLimite = this.erroBuscaLimite;

        if (
          this.taker.info.id == this.idTomadorPesquisaLimites &&
          !this.erroBuscaLimite
        ) {
          this.taker.info = limitsInfo;
          this.idTomadorPesquisaLimites = 0;
          this.buscandoLimite = false;
          this.limitesAgrupadosPorModalidade = this.groupBy(
            this.taker.info.sublimites,
            "modalidade"
          );
        }
      }
      this.cadastro_revisado = this.taker.info.cadastro_revisado
      await this.$nextTick();
      this.$forceUpdate();
    },

    getTakerAlertMessage(taker) {
      if (taker.status_nomeado == "OUTRO_NOMEADO") {
        return "Tomador já possui corretor nomeado, favor inserir a Carta de Nomeação.";
      }
      return "Cadastro salvo com sucesso!";
    },

    unselectTaker() {
      let t = this;
      this.$set(this.taker, "info", false);
      this.showSelectTaker = true;
      this.stepCompleted = 0;
      this.taker.showFormEconomicGroup = false;
      this.cadastro_revisado = ""

      this.taker.hasParticipants = false;
      this.takerParticipants = [];
      this.$forceUpdate();
    },

    preparePerson(person) {
      person.nome = person.name;
      person.endereco = person.enderecos[0];
      person.endereco.logradouro = [
        person.endereco.rua,
        person.endereco.numero,
        person.endereco.complemento,
      ].join(", ");

      delete person.notFound;
      delete person.enderecos;
      delete person.stepType;
      delete person.name;
      delete person.endereco.rua;
      delete person.endereco.numero;
      delete person.endereco.complemento;
      return person;
    },

    handleSameCNPJTakerInsured() {
      let e = {
        response: {
          data: {
            title: "Por favor, escolha outro CNPJ",
            message: "Tomador e segurado não podem ser iguais.",
            id:"passo2erros"
          },
          status: 409,
        },
      };
      this.defaultHandlerError(e);
    },

    async salvarSegurado() {
      if(this.$refs.novoSegurado.validate() &&
        this.$refs.formEnderecoComponent.$refs.formEndereco.validate()){
        let data;

        try {
          this.showLoadingAskWait();

          data = await this.$store.dispatch("INSERT_INSURED", {
            document:this.insured.cnpj.replace(/[^\w\s]/gi, ""),
            data:{
              tipo_pessoa: "FISICA",
              nome:this.insuredName,
              endereco:{...this.insuredAddress, numero: this.insuredAddress.numero || 'SN'}
            }
          });
        } catch (e) {
          if (e && e[0] && !e[0].ativo) {
            return this.handleInactivePersonError(e[0], "Segurado");
          }
          this.defaultHandlerError(e);
        } finally {
          this.modalNome = false;
          this.hideLoadingAskWait();
        }

        this.alertText = this.handleAlertText2(
          "Cadastro salvo com sucesso!"
        );

          this.insured.info = {...data, nome: data.nome.toUpperCase()};
          this.tipo_pessoa = this.insured.info.tipo_pessoa;

        this.stepCompleted = 2;
        this.modalNome = false;
        await this.$nextTick();
        this.$forceUpdate();
      }
    },

    async getInsuredByCNPJ() {
      if (!this.insured.cnpj) return;

      if (!isValidCnpj(this.insured.cnpj)) {
        let options = {
          code: 7001,
          details: null,
          message:
            "O CNPJ informado não é valido, por favor, corrija e tente novamente.",
          title: "CNPJ inválido",
          id:"passo2erros"
        };

        this.setErrorModal(options);
        return;
      }

      let data;
      let document = this.insured.cnpj.replace(/[^\w\s]/gi, "");

      try {
        this.showLoadingAskWait();
        data = await this.$store.dispatch("GET_INSURED_DATA", { document });
      } catch (e) {
        if (e && e[0] && !e[0].ativo) {
          return this.handleInactivePersonError(e[0], "Segurado");
        }
        e.response.data.id="passo2erros"
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }

      if (!data) return;
      if (data[0].id == this.taker.info.id) {
        this.handleSameCNPJTakerInsured();
        return;
      }
      this.alertText = this.handleAlertText2(
        "Cadastro recuperado com sucesso!"
      );

      this.insured.info = data[0];
      this.insured.info.nome = this.insured.info.nome.toUpperCase();
      this.tipo_pessoa = this.insured.info.tipo_pessoa;

      this.stepCompleted = 2;
      await this.$nextTick();

      this.$forceUpdate();
    },

    async getInsuredByCPF() {
      let t = this;
      if (!this.insured.cnpj) return;

      if (!isValidCpf(this.insured.cnpj)) {
        let options = {
          code: 7001,
          details: null,
          message:
            "O CPF informado não é valido, por favor, corrija e tente novamente.",
          title: "CPF inválido",
        };

        this.setErrorModal(options);
        return;
      }

      let data;
      let document = this.insured.cnpj.replace(/[^\w\s]/gi, "");

      try {
        this.showLoadingAskWait();

        data = await this.$store.dispatch("GET_INSURED_DATA", { document });
      } catch (e) {
        if (e && e[0] && !e[0].ativo) {
          return this.handleInactivePersonError(e[0], "Segurado");
        }
        e.response.data.id="passo2erros"
        this.defaultHandlerError(e);
      } finally {
        this.hideLoadingAskWait();
      }

      // Se não encontrar o CPF deverá ser informado no nome para cadastro
      if (data.length == 0) {
        this.hideLoadingAskWait();
        // Demonstra a modal para informar o nome
        this.insuredAddress ={};
        this.insuredName = null;
        this.$refs.novoSegurado.reset();
        this.$refs.formEnderecoComponent.$refs.formEndereco.reset();
        this.modalNome = true;
      } else {
        this.insured.info = data[0];
        this.tipo_pessoa = this.insured.info.tipo_pessoa;
        this.insured.info.nome = this.insured.info.nome.toUpperCase();

        this.alertText = this.handleAlertText2(
          "Cadastro recuperado com sucesso!"
        );

        this.stepCompleted = 2;
        await this.$nextTick();

        this.$forceUpdate();
      }
    },

    selectInsured(insured) {
      let t = this;
      if (!insured.ativo) return;
      this.$set(this.insured, "info", insured);
      this.showListToSelectInsured = false;
      this.stepCompleted = 2;
      this.$forceUpdate();
    },

    unselectInsured() {
      let t = this;
      this.$set(this.insured, "info", false);
      if (this.insuredName) this.insuredName = "";
      this.showListToSelectInsured = true;
      this.stepCompleted = 1;
      this.$forceUpdate();
    },

    async getInsuredByRazaoSocial(options = {}) {
      let t = this;
      if (!this.insured.name) return;
      let data = [];
      let name = this.insured.name;
      let personType =
        this.insured.stepType == 2 ? "CONSORCIO" : "ORGAO_PUBLICO";
      try {
        this.showLoadingAskWait();
        data = await this.$store.dispatch("GET_INSURED_DATA_RAZAOSOCIAL", {
          name,
          personType,
        });
      } catch (e) {
        console.error(e);
        let type = "insured";
        this.set404ErrorMessage(e, type);
        this.defaultHandlerError(e);
        this.showListToSelectInsured = false;
        if (!isCNPJ(name)) {
          this.insured.enderecos = [{}];
          this.insured.notFound = true;
          this.lastInsuredSearchWasCNPJ = false;
        } else {
          // if(this.insured.stepType == 2) {
          this.insured.notFound = false;
          this.lastInsuredSearchWasCNPJ = true;
          // }
        }
      } finally {
        this.hideLoadingAskWait();
      }
      await this.$forceUpdate();
      await this.$nextTick();

      if (!data.length) return;
      // se o resultado não for através de uma busca por CNPJ
      // exibe a listagem de takers
      // mas se for, seleciona o primeiro resultado direto
      this.insuredResults = data;
      if (!isCNPJ(name)) {
        this.showListToSelectInsured = true;
        this.insured.notFound = false;
      } else {
        this.selectInsured(data[0]);
      }
      this.$forceUpdate();

      await this.$nextTick();
    },

    set404ErrorMessage(e, type) {
      let person =
        type == "taker" ? "tomador" : type == "insured" ? "segurado" : false;

      let errorMessage = {
        title: `${capitalize(person)} não encontrado`,
        message: `Não foi encontrado nenhum ${person}`,
      };

      if (e.response.status == 404 || e.response.status == 200) {
        e.response.data = errorMessage;
        e.response.status = 404;
      }
      return;
    },

    handleInactivePersonError(e, personType) {
      let t = this;
      let options = {
        title: `${personType} Inativo`,
        message: `Desculpe, este ${personType} não é compatível com a política da JNS Seguradora.`,
      };
      this.setErrorModal(options);
      return;
    },

    addNewParticipant(participant) {
      let t = this;
      this.participanteModal = false;
      if (!participant.info) {
        participant.info = [];
      }

      this.$set(
        participant,
        "porcentagem",
        this.takerParticipants.length ? 0 : 100
      );

      this.takerParticipants.push(participant);
      this.reloadParticipanteModal = false;

      this.$nextTick(() => {
        this.reloadParticipanteModal = true;
        this.$forceUpdate();
      });
      this.$forceUpdate();
    },

    async getProposalProducts() {
      let t = this;
      let data;
      try {
        data = await this.$store.dispatch("GET_PROPOSAL_PRODUCTS", {
          takerId: this.taker.info.id,
          insuredId: this.insured.info.id,
        });
      } catch (e) {
        this.defaultHandlerError(e);
        return false;
      }
      this.productGroups = data;
      this.selectedProductGroup = "0";
      if (this.productGroups.length == 0) {
        this.selectedProduct = false;
        this.semProdutos = true;
      } else {
        let temModalidades = false;
        this.productGroups.forEach((element) => {
          if (element.modalidades.length > 0) temModalidades = true;
        });

        if (!temModalidades) {
          this.selectedProduct = false;
          this.semProdutos = true;
        }
      }
      return true;
    },

    prepareProducts() {
      let t = this;

      let products = [];
      products.push(t.selectedProduct);
      if (t.selectedAdditionalCoverages.length)
        products.push(...t.selectedAdditionalCoverages);

      if (t.selectedCoverages.length) products.push(...t.selectedCoverages);

      return products;
    },

    prepareObjectTags() {
      let match = null;
      let regex = /\%TAG_(.*?)\%/gi;
      let counter = 0;
      this.TAGs = [];

      if (!this.product) {
        this.selectedProduct = false;
        return false;
      }
      let tagNames = [];

      while ((match = regex.exec(this.product.objeto)) != null) {
        let tagName = match[1].trim();
        if (!tagNames.includes(tagName)) {
          tagNames.push(tagName);
        }
      }

      for (let tagName of tagNames) {
        counter++;
        this.TAGs.push({
          original: tagName,
          label: tagName,
          id: tagName.replace(".", ""),
          value: "",
        });
      }

      counter = 0;
      this.product.objeto = this.product.objeto.replace(regex, (match, p1) => {
        counter++;
        p1 = p1.replace(/\./g,'').trim().replace(/\(|\)/g,'');
        return (
          " <span class='font-weight-bold proposta__tag-text " +
          this.setSpaces(p1) +
          "'>[" +
          p1 +
          "]</span> "
        );
      });
    },

    checkIfDisabled(step, stepCompleted) {
      let t = this;

      if (!this.taker.info || this.buscandoLimite) {
        return true;
      } else if (
        (!this.taker.info.situacao_ativo || !this.taker.info.ativo) &&
        this.compareWithToday(this.taker.info.data_validade_limite)
      )
        return true;
      else if (
        this.taker.info.limite_disponivel <= 0 &&
        this.taker.info.cadastro_revisado == "REVISADO" &&
        this.compareWithToday(this.taker.info.data_validade_limite)
      )
        return true;

      if (+step == 1 && this.taker.stepType == 2) {
        let participantsComission = 0;
        if (!this.takerParticipants.length) return true;

        participantsComission = this.takerParticipants
          .map((item) => +item.porcentagem)
          .reduce((acc, cur) => acc + cur);

        return participantsComission != 100;
      }

      if (this.erroBuscaLimiteRequest) return true;

      if (+step == 3) {
        return this.selectedProduct == false;
      }

      if ([1, 2, 3].includes(+step)) {
        return this.stepCompleted < step;
      }

      if (+step == 4) {
        return !this.checkIfProposalIsFulfilled();
      }
    },

    checkIfProposalIsFulfilled(debug = false) {
      let allowToFinish = true;
      let product = this.product;
      let tags = this.TAGs;
      // por alguma razao foreach não quer pegar
      let coberturas = product.coberturas.filter((item) => {
        if (item.tipo != "adicional") return item;
      });
      for (let a in coberturas) {
        let cobertura = coberturas[a];
        if (
          !cobertura.inicio_vigencia ||
          !cobertura.fim_vigencia ||
          !cobertura.importancia_segurada
        ) {
          allowToFinish = false;
        } else {
          if (cobertura.importancia_segurada == "R$ 0,00") {
            allowToFinish = false;
          }
        }
      }
      for (let j in tags) {
        let tag = tags[j];
        if (!tag.value) allowToFinish = false;
      }
      if (this.taker.info.cadastro_revisado != "NAO_REVISADO") {
        let coberturaBasica = product.coberturas.find(
          (item) => item.tipo == "basica"
        );
        let tomadorLimiteCoberturaBasica = this.taker.info.sublimites.find(
          (item) => {
            item.modalidade == coberturaBasica.nome_comercial;
          }
        );
      }

      return allowToFinish;
    },

    getModalidadeNameByType(type) {
      let modalidade =
        type == "basica"
          ? "Modalidade Principal"
          : type == "corretiva"
          ? "Modalidade Complementar"
          : false;
      return modalidade;
    },

    changeTagPlaceholderContent(event, tag) {
      let t = this;
      let id = this.setSpaces(tag.id);
      id = id.replace(/\(|\)/g, "");
      id = id.replaceAll('/', '\\/');

      let els = document.querySelectorAll("." + id);
      els.forEach(function (el) {
        el.innerHTML = tag.value == "" ? `[${tag.id}]` : tag.value;
      });

      this.$forceUpdate();
    },

    checkIfPersonAddressIsEmpty(person) {
      return (
        person &&
        person.info &&
        !person.info.endereco &&
        person.info.tipo_pessoa != "FISICA"
      );
    },

    getEmptyAddressErrorMessage(step) {
      const person = step == 1 ? "Tomador" : "Segurado";
      let message = {
        title: `${person} indisponível`,
        message: `${person} sem endereço cadastrado junto a seguradora. Por favor entre em contato com o Administrador.`,
        status: 405,
      };
      return message;
    },

    async prepareStep5Edit() {
      let response;
      let payload = {
        id_produto: this.$route.params.produtoId,
        id_proposta: this.$route.params.propostaId,
      };
      this.showLoadingAskWait();
      try {
        response = await this.$store.dispatch("GET_PROPOSAL", payload);
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      if (response.status != "CORRETOR_ANALISE_EMISSAO") {
        this.$router.push({ path: "/mesa-de-trabalho" });
      }
      this.mostraBtnQuestionamento = true;
      this.isStep5Edit = false;
      this.proposta = response;
      this.defineUrlCliqueAqui();
      this.step = 5;
    },

    async desistir() {
      console.warn("desistindo da proposta");

      // Buscar motivos
      try {
        this.motivos = await this.$store.dispatch("GET_REASONS");
      } catch (e) {
        this.defaultHandlerError(e);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      if (this.step != 5) {
        this.confirmQuitModal = true;
        this.modalDesistir = true;
      } else {
        this.confirmQuitModal = false;
        this.modalDesistir = true;
      }
    },

    showQuestionamento() {
      this.dialogQuestionamento = true;
    },

    // Validar o disable da solicitação de análise passo 4
    desabilitaSolicitarAnalise() {
      if (this.buscandoLimite) {
        return true;
      } else {
        return this.checkIfDisabled(this.step, this.stepCompleted);
      }
    },

    semProdutosClick() {
      this.semProdutos = false;
    },

    async buscarParametros() {
      let parameters = await this.$store.dispatch("GET_PARAMETERS");
      return parameters;
    },

    async buscarParametrosTomador() {
      let parameters = await this.$store.dispatch("GET_PARAMETERS_TOMADOR");
      return parameters;
    },

    /* Direcionamento de cada etapa (avançar) */
    async goToNextStep(step) {
      let t = this;
      let products;

      if (
        ((step == 1 || step == 2) &&
          this.checkIfPersonAddressIsEmpty(this.taker)) ||
        this.checkIfPersonAddressIsEmpty(this.insured)
      ) {
        this.defaultHandlerError({
          response: {
            data: this.getEmptyAddressErrorMessage(step),
          },
        });
        return;
      }

      if (
        step == 1 &&
        this.taker.stepType == 2 &&
        this.takerParticipants.length
      ) {
        this.showLoadingAskWait();

        let payload = {

          id_tomador: this.taker.info.id,
          participantes: this.takerParticipants.map((participant) => {
            let res = {
              id_participante: participant.id_participante,
              porcentagem: +participant.porcentagem,
            };
            return res;
          }),
        };
        this.$store
          .dispatch("INSERT_CONSORCIO", payload)
          .then(() => {
            this.hideLoadingAskWait();
            this.step++;
            this.$nextTick(this.$forceUpdate);
            return;
          })
          .catch((e) => {
            this.defaultHandlerError(e);
          });
        return;
      }
      if (step == 2) {
        this.showLoadingAskWait();

        this.getProposalProducts().then((response) => {
          this.hideLoadingAskWait();
          if (response) {
            if (this.productGroups.length == 0) {
              this.selectedProduct = false;
              this.semProdutos = true;
            } else {
              let temModalidades = false;
              this.productGroups.forEach((element) => {
                if (element.modalidades.length > 0) temModalidades = true;
              });

              if (!temModalidades) {
                this.selectedProduct = false;
                this.semProdutos = true;
              } else {
                this.step = 3;
                this.$nextTick(this.$forceUpdate);
              }
            }
          } else {
            this.step = 2;
          }
          return;
        });
      } else if (step == 3) {
        products = this.prepareProducts();
        this.showLoadingAskWait();
        let payload = {
          products,
          takerId: this.taker.info.id,
          insuredId: this.insured.info.id,
        };

        try {
          this.$store
            .dispatch("GET_PRODUCTS", payload)
            .then((response) => {
              this.hideLoadingAskWait();
              this.product = response;
              this.step++;
              this.prepareObjectTags();
              this.$nextTick(this.$forceUpdate);
              return;
            })
            .catch(this.handleError);
        } catch (e) {
          this.defaultHandlerError(e);
          this.step = 3;
        }

        try {
          let parameters = await this.buscarParametrosTomador();
          this.parametersTomador = parameters.conteudo;
        } catch (e) {
          this.defaultHandlerError(e);
        }
      } else if (step == 4) {
        if (
          !this.tomadorAnaliseCredito &&
          !this.taker.info.sublimites.length &&
          this.me.company.classificacao == "DIGITAL"
        ) {
          this.dialogAnaliseCredito = true;
          this.$forceUpdate();
          return;
        } else this.dialogResumoProposta = true;

        let objeto = this.product.objeto;

        this.TAGs.forEach((tag) => {
          objeto = objeto.replace(`[${this.replaceTagObject(tag.id)}]`, tag.value);
        });

        this.resumoProposta = {
          tomador: {
            cnpj_cpf: this.taker.info.cnpj_cpf,
            nome: this.taker.info.nome,
            endereco: this.taker.info.endereco,
          },
          segurado: {
            cnpj_cpf: this.insured.info.cnpj_cpf,
            nome: this.insured.info.nome,
            endereco: this.insured.info.endereco,
          },
          modalidade: {
            grupo: this.product.ramo,
            principal: this.product.nome_produto,
          },
          objeto: objeto,
          coberturas: [],
          tags: [],
        };

        this.product.coberturas.forEach((element) => {
          this.resumoProposta.coberturas.push({
            nome: element.nome_comercial,
            tipo: element.tipo,
            importancia_segurada:
              typeof element.importancia_segurada == "string"
                ? parseFloat(
                    element.importancia_segurada
                      .replace("R$ ", "")
                      .replace(/\./g, "")
                      .replace(",", ".")
                  )
                : element.importancia_segurada,
            inicio_vigencia_formatted: element.inicio_vigenciaFormatted,
            fim_vigencia_formatted: element.fim_vigenciaFormatted,
          });
        });
        this.$forceUpdate();
        return;
      } else {
        this.step++;
        this.$nextTick(this.$forceUpdate);
      }
    },

    async redirecionarDocumentacaoTomador() {
      const id = this.taker.info.id
      this.showLoadingAskWait();

      let payload = {
          id: id,
        };
        try {
          if(this.taker.info.documentos.length > 0) {
          this.$store
            .dispatch("POST_LIMPAR_DOCUMENTOS", payload)
            .then((response) => {
              this.$router.push({path: `/tomadores/${this.cnpjTomador}/1`, query: { tab: 'revisao-credito' }})

            })
            .catch(this.handleError);
        }
        else {
          this.$store
            .dispatch("CRIAR_DOCUMENTOS_TOMADOR", payload)
            .then((response) => {
              this.$router.push({path: `/tomadores/${this.cnpjTomador}/1`, query: { tab: 'revisao-credito' }})

            })
            .catch(this.handleError);
        }

        } catch (e) {
          this.defaultHandlerError(e);
        }
    },

    replaceTagObject(tag){
      return tag.replace(/\(|\)/g,'');
    },

    closeResumoProposta() {
      this.$nextTick(() => {
        this.resetScroll();
      });
      this.dialogResumoProposta = false;
      this.$forceUpdate();
    },

    /* TODO: Novos processos para envio no Passo 4 - Apólice

      Ao enviar os documentos é realizado o inicio do processamento
      1 - Envio da proposta
      2 - Envio dos arquivos
      3 - Aprovação automática de crédito
      4 - Aprovação automática de subscrição
      5 - Aprovação automática de resseguro
    */
    async setEmailFollowUp(){
      localStorage.setItem('@email_folow_up', this.inputEmail);
      this.dialogFollowUp = false;
      this.processTheRequest();
    },

    async keyUpEnterSetEmailFollowUp(){
      if(this.validFollowUp){
        this.setEmailFollowUp();
      }
    },

    async postEmailFollowUp(payload){

      this.emailFollowUp = localStorage.getItem('@email_folow_up');

      let newPayload = {
        email: this.emailFollowUp,
        id_produto: payload.id_produto,
        id_proposta: payload.id_proposta
      };

      try {
        await this.$store.dispatch("POST_EMAIL_FOLLOW_UP", newPayload);
      } catch (e) {
        console.warn(e);
      } finally {
        localStorage.removeItem('@email_folow_up');
      }
    },

    async processTheRequest() {
      let salvarProposta = false;

      let inportanceValue = this.moneyToFloat(
        this.product.coberturas[0].importancia_segurada
      );

      if (this.validateLimitByProduct(inportanceValue)) {
        this.dialogProcessandoSolicitacao = true;


        this.saveProposal({ status: "EM_ANALISE", step: 4 });
      }
    },

    fecharAnaliseCreditoModal(data) {
      this.taker.tomador_credito = data;
      this.dialogAnaliseCredito = false;
      this.$forceUpdate();
    },

    solicitarLimitesAnaliseCredito(data) {
      this.resetScroll();
      this.tomadorAnaliseCredito = data;
      this.dialogAnaliseCredito = false;
      this.getLimite();
      this.$forceUpdate();
    },

    // Validar a importância segurada com o limite para o produto selecionado se cadastro != NAO_REVISADO
    validateLimitByProduct(inportanceValue) {
      let limitByProductValid = true;

      /* FIXME: Novo processo de validação do limite por produto necessário devido a atualização no backend.*/

      return limitByProductValid; // Não validando neste momento.
    },

    // Salvar a proposta e executar os processos
    async saveProposal(options) {
      let t = this;
      let response;
      let payload = this.prepareProposalPayload();
      this.restartProccess();

      if (options && options.status) {
        payload.status = options.status;
      }

      let processExecuted = false;

      try {
        this.startProcess(1);
        response = await t.$store.dispatch("POST_PROPOSTA", payload);

          let payloadEmail = {
            id_produto: response.id_produto,
            id_proposta: response.id,
          }

          Promise.all([this.postEmailFollowUp(payloadEmail)]);
        if (response) {
          this.endProcess(1, "success", response.id);
        }
        else {
          this.endProcessAndFinalize(1, "error");
          return;
        }
      } catch (e) {
        this.endProcessAndFinalize(1, "error", e);
        return;
      }

      if (response.status === "EM_CADASTRO" && options && options.step === 4) {
        this.startProcess(2);

        try {
          payload.status = "ANALISE_CREDITO";
          payload.id_proposta = response.id;
          payload.id_produto = response.id_produto;
          response = await t.$store.dispatch("PATCH_PROPOSTA", payload);
          if (response) {
            this.id_proposta = response.id;
            this.id_produto = response.id_produto;
            this.propostaId = response.id;
            this.produtoId = response.id_produto;
          } else {
            this.endProcessAndFinalize(2, "error");
            return;
          }
        } catch (e) {
          this.endProcessAndFinalize(2, "error", e);
          return;
        }

        this.statusProposta = response.status;

        /* ------------- Análise de Crédito ---------- */
        if (
          response.status == "PROPOSTA_RECUSADA" ||
          response.status == "RECUSADA"
        ) {
          let args = {
            message: "Proposta recusada na análise automática de crédito.",
          };
          this.endProcessAndFinalize(2, "error", args);
          return;
        } else if (
          response.status == "CORRETOR_ANALISE_CREDITO" ||
          response.status == "SEGURADORA_ANALISE_CREDITO"
        ) {
          if (response.status == "CORRETOR_ANALISE_CREDITO")
            this.tabDetalharProposta = "#credito";
          this.endProcessAndFinalize(2, "error");
          return;
        } else if (response.status == "SEGURADORA_ANALISE_SUBSCRICAO") {
          /* ---------- Análise de Subscrição -----*/

          this.endProcess(2, "success");

          this.startProcess(3);

          try {
            payload.status = "ANALISE_SUBSCRICAO";
            payload.id_proposta = response.id;
            payload.id_produto = response.id_produto;
            response = await t.$store.dispatch("PATCH_PROPOSTA", payload);
            if (response) {
              if (response.status == "SEGURADORA_ANALISE_SUBSCRICAO") {
                this.endProcessAndFinalize(3, "error", {
                  message:
                    "A proposta foi direcionada para análise de subscrição.",
                });
                return;
              } else if (response.status == "CORRETOR_ANALISE_EMISSAO") {
                this.endProcess(3, "success");
                this.startProcess(4);

                this.actualProcessStepErrorMessage =
                  "Proposta aprovada automaticamente.";
                this.processSuccess = true;
                this.endProcess(4, "success");
                this.finalizeProcess();
                return;
              } else {
                this.endProcessAndFinalize(3, "error");
                this.tabDetalharProposta = "#subscricao";
                return;
              }
            } else {
              this.endProcessAndFinalize(3, "error");
              return;
            }
          } catch (e) {
            this.endProcessAndFinalize(3, "error", e);
            return;
          }
        } else if (response.status == "CORRETOR_ANALISE_SUBSCRICAO") {
          this.tabDetalharProposta = "#subscricao";
          this.endProcessAndFinalize(3, "error");
          return;
        } else if (response.status == "CORRETOR_ANALISE_RESSEGURO") {
          this.tabDetalharProposta = "#resseguro";
          this.endProcessAndFinalize(4, "error");
          return;
        }
      }

      // Finalizar todo os processos
      this.finalizeProcess();
    }, // ./saveProposal

    // Payload da proposta
    prepareProposalPayload() {
      let prepareCoberturas = (coverages) => {
        if (coverages.tipo == "adicional") {
          return { id: coverages.id_cobertura };
        }
        let valorCobertura = coverages.importancia_segurada;
        if (coverages.importancia_segurada.toString().substring(0, 2) == "R$") {
          valorCobertura = coverages.importancia_segurada
            .toString()
            .replace("R$ ", "")
            .replace(/\./g, "")
            .replace(",", ".");
        }

        let res = {
          id: coverages.id_cobertura,
          importancia_segurada: valorCobertura,
          inicio_vigencia: coverages.inicio_vigencia,
          fim_vigencia: coverages.fim_vigencia.split("/").reverse().join("-"),
        };
        return res;
      };
      let prepareTags = (tag) => {
        let res = {
          valor: tag.value,
          tag: tag.label.trim(),
        };
        return res;
      };

      return {
        id_proposta: this.id_proposta,
        id_segurado: this.insured.info.id,
        id_tomador: this.taker.info.id,
        id_produto: this.product.id_produto,
        status: "",
        coberturas: this.product.coberturas.map(prepareCoberturas),
        tags: this.TAGs.map(prepareTags),
      };
    }, // ./prepareProposalPayload

    startProcess(step) {
      this.dialogProcessandoSolicitacao = true;
      this.processInExecution = true;
      this.processSteps.find((item) => item.step == step).display = true;
    }, // ./startProcess

    endProcess(step, status, args) {
      this.processSteps.find((item) => item.step == step).status = status;
      if (status == "success")
        this.processSteps.find(
          (item) => item.step == step
        ).text = this.processSteps
          .find((item) => item.step == step)
          .success_text.replace("arg", args);
      else if (status == "error") {
        this.actualProcessStepErrorMessage = "";
        if (args != null) {
          if (args.response) {
            if (args.response.data) {
              this.actualProcessStepErrorMessage = args.response.data.message;
            }
          } else if (args.message != null) {
            this.actualProcessStepErrorMessage = args.message;
            if (args.details != null) {
              this.actualProcessStepErrorMessage += "</br>" + args.details;
            }
          } else {
            this.actualProcessStepErrorMessage = this.processSteps.find(
              (item) => item.step == step
            ).error_text;
          }
        } else {
          if (
            this.processSteps.find((item) => item.step == step).details != null
          ) {
            if (this.statusProposta.includes("RECUSADA"))
              this.actualProcessStepErrorMessage = this.processSteps.find(
                (item) => item.step == step
              ).details.recusado;
            else if (this.statusProposta.includes("CORRETOR"))
              this.actualProcessStepErrorMessage = this.processSteps.find(
                (item) => item.step == step
              ).details.corretor;
            else
              this.actualProcessStepErrorMessage = this.processSteps.find(
                (item) => item.step == step
              ).details.seguradora;
          } else {
            this.actualProcessStepErrorMessage = this.processSteps.find(
              (item) => item.step == step
            ).error_text;
          }
        }

        this.processSteps.find(
          (item) => item.step == step
        ).text = this.processSteps.find((item) => item.step == step).error_text;
      }
    }, // ./endProcess

    // Finalizar um processo e juntamente finalizar todo o processo
    endProcessAndFinalize(step, status, args) {
      this.endProcess(step, status, args);
      this.finalizeProcess();
      return;
    }, // ./endProcessAndFinalize

    finalizeProcess(clean) {
      this.processInExecution = false;
      this.isProcessing = false;
    }, // ./finalizeProcess

    restartProccess() {
      this.processSuccess = false;
      this.processInExecution = false;
      this.actualProcessStepErrorMessage = "";
      this.processSteps.forEach((item) => {
        item.display = false;
        item.status = "pending";
      });
    }, // ./restartProccess

    goto(sector) {
      if (sector == "timeline") {
        this.$router.push({
          path: `/proposta/${this.id_proposta}/${
            this.id_produto + this.tabDetalharProposta
          }`,
        });
      } else if (sector == "mesa") {
        this.$router.push({ path: "/mesa-de-trabalho" });
      } else {
        this.dialogProcessandoSolicitacao = false;
        this.$router.push({
          path: `/proposta/editar/${this.id_proposta}/${this.id_produto}`,
        });
        this.$router.go();
      }
    }, // ./ goto

    boqueiaUnloadPage(evt) {
      if (this.isProcessing) {
        evt.returnValue = true;
        return true;
      }
    },

    async getMinuta() {
      let payload = {
        id_produto: this.apolice.id_produto,
        id_proposta: this.apolice.id_proposta,
      };
      try {
        this.showLoadingAskWait();
        await this.$store.dispatch("GET_MINUTA", payload);
      } catch (e) {
        let options = {
          code: null,
          details: null,
          message: "Não foi possível gerar a minuta da proposta.",
          title: "Minuta não disponível",
        };
        this.defaultHandlerError(options);
        return;
      } finally {
        this.hideLoadingAskWait();
      }

      this.hideLoadingIndicator();
      this.$forceUpdate();
    },

    updateInsuredInfo(info){
      this.insured.info = info;
      this.$forceUpdate();
    }
  },
  mounted() {
    let t = this;

    this.$store.commit("SET_PAGENAME", t.$route.name);
    this.timeline = this.$settings.mocks.timeline;
    if (this.$route.params.propostaId && this.$route.params.produtoId) {
      this.mostraCampoUploadQuestionamento = true;
      this.isStep5Edit = true;
      this.id_proposta = this.$route.params.propostaId;
      this.id_produto = this.$route.params.produtoId;

      this.prepareStep5Edit();
      this.loadTermos();
      this.defineUrlCliqueAqui();
    }

    this.$forceUpdate();
  },
  beforeMount() {
    window.addEventListener("beforeunload", this.boqueiaUnloadPage);
  },
  watch: {
    dialogProcessandoSolicitacao: function (value) {
      if (value && this.step == 4) this.isProcessing = true;
      else this.isProcessing = false;

      return value;
    },

    step: function (newValue) {
      window.scrollTo(0, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
.v-text-field__prefix {
  text-align: left !important;
  padding-left: 10px !important;
  padding-right: 0px !important;
}

/* Slider */
.v-slider__thumb-label,
.v-slider__thumb-label__container {
  position: static !important;
}

.v-slider__thumb {
  width: 0px !important;
  height: 0px !important;
  background: transparent;
}

.v-slider__thumb-label {
  width: 18px !important;
  height: 18px !important;
  span {
    top: 110%;
    position: relative;
    left: 90%;
    color: #282498;
    font-weight: bold;
  }
}

.v-slider__thumb-label span {
  display: none;
}

#jns {
  .proposta__container {
    height: 100%;
    height: calc(100% - 77px);
    max-height: 80vh;
    overflow: hidden;

    .white_background {
      height: 67vh;
    }
  }

  .proposta__container-passo-5 {
    height: 90vh;

    .white_background {
      height: 72vh;
    }
  }

  .white_background {
    padding-top: initial;
    margin-top: 30px;
    overflow: auto;
  }

  .white_background .pull-right {
    text-align: right;
  }
  .info-red {
    color: #d21a5e;
  }
  .mt-30neg {
    margin-top: -30px;
  }
  .p-rel {
    position: relative;
  }
  .custom-i {
    font-size: 18px;
    cursor: pointer;
  }
  .bold {
    font-weight: bold;
  }
  .no-padding-top {
    padding-top: 0 !important;
  }
  .no-padding-bottom {
    padding-bottom: 0 !important;
  }
  .msg-tomador-container {
    width: 30%;
    background-color: #fff;
    position: absolute;
    z-index: 999;
    box-shadow: 0 0 1em #ccc;
    padding: 12px;
    right: 30px;
    top: 0px;

    p {
      text-align: left;
      margin-bottom: 0;
      font-weight: normal;

      &.info-red {
        margin-bottom: 5px;
      }
    }
  }

  .proposta__footer {
    padding: 34px 24px 0 24px !important;
    height: 12vh !important;
  }

  .jns-button {
    font-size: 16px;
    text-transform: none;
    margin: 6px 12px;
  }

  .readonly_button {
    background: #dddddd !important;
    color: rgba(0, 0, 0, 0.26) !important;
    box-shadow: none !important;
    cursor: not-allowed;
    //pointer-events: none;
  }

  .box-card-follow-up {
    color: #282498;
    width: 100%;
    margin: 0;
    padding: 0;

    .box-card-follow-up-title {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      margin: 0 0 2rem 0;
      padding: 0;
    }

    .box-card-follow-up-buttons {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin: 2rem 0 0 0;
      padding: 0;

      .jns-button {
        margin: 0;
        padding: 0;
        width: 48%;
      }
    }

    @media screen and (max-width: 451px) {
      .box-card-follow-up-title {
        margin-bottom: 2rem;
      }

      .box-card-follow-up-buttons {
        flex-direction: column;
        margin-top: 1rem;

        .jns-button {
          width: 100%;
          margin: 0.5rem 0;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// ./src/router/views/Propostas/Propostas.vue